export const storeLocatorMixin = {
  computed: {
    title() {
      const choice = this.choices.find(
        choice => choice.value === this.sectionType
      );
      return choice ? choice.title : "";
    },
    description() {
      const choice = this.choices.find(
        choice => choice.value === this.sectionType
      );
      return choice ? choice.description : "";
    }
  }
};
